<img src="/assets/img/close-modal.svg" class="modal__close" (click)="close()">
<div class="feature-not-available">
    <img src="/assets/img/logo.svg" alt="SGC">
    <h3>Something new is coming!</h3>
    <p>{{getMessage()}}</p>
    <button class="button" (click)="takeAction()" *ngIf="hasAction()">{{getActionLabel()}}</button>
</div>